var image_orientation = -1;
var imageHeight, imageWidth;

window.addEventListener("load", function(){

});

window.addEventListener("resize", function() {
  setCanvasSize(imageWidth, imageHeight);
});

function setCanvasSize(width, height) {

  var divideOffset = 2;
  if(window.innerWidth <= 480) {
    divideOffset = 1;
  } else {    
    divideOffset = 2;
  }

  imageHeight = height;
  imageWidth = width;
  var ratio = height/width;
  var canvas = document.getElementById('outCanvas');
  var image = document.getElementById('original-image');
  var context = canvas.getContext('2d');
  switch(image_orientation){
    case 8:
      canvas.getContext('2d').rotate(90*Math.PI/180);
      break;
    case 3:
      canvas.getContext('2d').rotate(180*Math.PI/180);
      break;
    case 6:
      canvas.getContext('2d').rotate(-90*Math.PI/180);
      break;
  }
  context.canvas.width = ((document.getElementById("image-container").offsetWidth/divideOffset)-24);
  context.canvas.height = ((document.getElementById("image-container").offsetWidth/divideOffset)-24) * ratio;
  context.canvas.style.width = ((document.getElementById("image-container").offsetWidth/divideOffset)-24);
  context.canvas.style.height = ((document.getElementById("image-container").offsetWidth/divideOffset)-24) * ratio;
  image.width = ((document.getElementById("image-container").offsetWidth/divideOffset)-24);
  image.height = ((document.getElementById("image-container").offsetWidth/divideOffset)-24) * ratio;
  image.style.width = ((document.getElementById("image-container").offsetWidth/divideOffset)-24);
  image.style.height = ((document.getElementById("image-container").offsetWidth/divideOffset)-24) * ratio;
  panZoomImage.resetView();
}

jQuery(function($){
  $(".choose-btn").click(function(){
    $("#fileInput").click();
  });

  $("#fileInput").on("change",function(e){
    $(".file-name").html(e. target. files[0]. name);
  });

  $(".sa-view > h4").click(function(){
    $(this).parent().toggleClass("show");
  });
});

function openWindow(e) {
  var image = new Image();
  image.src = document.getElementById("imageLink").href;
  var w = window.open("");
  w.document.write(image.outerHTML);
}